// Yeni deploy sonrasi acik kalan sekme eski parca dosyasini (assets/x-HASH.js)
// ister; sunucuda artik yoktur. Sayfayi BIR KEZ yenileyip yeni surumu yukle
// (dongu olmasin diye 30 sn icinde ikinci kez yenilemez).
const KEY = "erc_stale_chunk_reload";

export function isStaleChunkError(err: unknown): boolean {
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported/i.test(String((err as Error)?.message ?? err));
}

export function reloadForStaleChunk(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 30_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch { /* depolama yok: yine de yenile */ }
  window.location.reload();
  return true;
}

export function installStaleChunkReload() {
  window.addEventListener("vite:preloadError", (e) => { if (reloadForStaleChunk()) e.preventDefault(); });
}
